import { Link } from 'react-router';

import styles from './shell.module.css';

/** Unknown address. Kept inside the shell so the owner can always get back. */
export function NotFoundScreen() {
  return (
    <div className={styles.screen}>
      <h1 className={styles.title}>Página no encontrada</h1>
      <p className={styles.message}>La dirección que abriste no existe en NoteVision.</p>
      <Link className={styles.link} to="/">
        Ir al inicio
      </Link>
    </div>
  );
}
